;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { VariantProps } from 'class-variance-authority'
import { ComponentProps } from 'react'

import { cn } from '../../utils/cn'
import { BaseAnchor } from './base-anchor'
import { buttonStyles } from './buttonStyles'

/**
 * A button-styled {@link BaseAnchor}. External links open in a new tab by
 * default, so you don't need to pass `target="_blank"`.
 */
export function Anchor({
  size,
  variant,
  className,
  ...props
}: ComponentProps<typeof BaseAnchor> & VariantProps<typeof buttonStyles>) {
  return (
    <BaseAnchor
      className={cn(buttonStyles({ variant, size }), className)}
      {...props}
    />
  )
}
